import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const FormsIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M28,.06H4a.76.76,0,0,0-.77.77V31.17a.76.76,0,0,0,.77.77H28a.76.76,0,0,0,.77-.77V.83A.76.76,0,0,0,28,.06Zm-.78,30.33H4.81V1.71H27.19Z"
      fill="current"
    />
    <path
      d="M8.78,9.65H12a.76.76,0,0,0,.77-.77V5.68A.76.76,0,0,0,12,4.9H8.78A.77.77,0,0,0,8,5.68v3.2A.84.84,0,0,0,8.78,9.65Zm.87-3.2H11.2V8H9.65Z"
      fill="current"
    />
    <path
      d="M15.18,6.45h7.94a.76.76,0,0,0,.78-.77.75.75,0,0,0-.68-.78H15.27a.77.77,0,0,0-.77.78A.74.74,0,0,0,15.18,6.45Z"
      fill="current"
    />
    <path d="M15.18,9.65h3.19a.78.78,0,1,0,0-1.55H15.18a.77.77,0,0,0-.78.78A.84.84,0,0,0,15.18,9.65Z" fill="current" />
    <path
      d="M8.78,17.6H12a.77.77,0,0,0,.77-.78V13.63a.76.76,0,0,0-.77-.78H8.78a.77.77,0,0,0-.78.78v3.19A.77.77,0,0,0,8.78,17.6Zm.87-3.1H11.2v1.55H9.65Z"
      fill="current"
    />
    <path d="M15.18,14.5h7.94a.78.78,0,1,0,0-1.55H15.18a.76.76,0,0,0-.78.77A.84.84,0,0,0,15.18,14.5Z" fill="current" />
    <path d="M15.18,17.6h3.19a.78.78,0,1,0,0-1.55H15.18a.77.77,0,0,0-.78.77A.84.84,0,0,0,15.18,17.6Z" fill="current" />
    <path
      d="M8.78,25.64H12a.76.76,0,0,0,.77-.77v-3.2a.76.76,0,0,0-.77-.78H8.78a.77.77,0,0,0-.78.78v3.2A.83.83,0,0,0,8.78,25.64Zm.87-3.2H11.2V24H9.65Z"
      fill="current"
    />
    <path
      d="M15.18,22.44h7.94a.76.76,0,0,0,.78-.77.77.77,0,0,0-.78-.78H15.18a.77.77,0,0,0-.78.78A.83.83,0,0,0,15.18,22.44Z"
      fill="current"
    />
    <path
      d="M15.18,25.64h3.19a.76.76,0,0,0,.78-.77.84.84,0,0,0-.78-.78H15.18a.77.77,0,0,0-.78.78A.83.83,0,0,0,15.18,25.64Z"
      fill="current"
    />
  </svg>
);
